import * as R from 'ramda'
import Moment from 'moment'
import createReducer from 'utils/redux/createReducer'

import { lastPropertyLease, leasesByApplicationID } from '../selectors/leases'
import { managersMentions } from 'utils/commentsText'
import { getlistingsByPropertyID } from '../selectors/application'

const initialState = {
    db: undefined
  , idx: undefined
  , replicated: ""
  , updated: undefined
  , buffer: {}
  , edit: ''
}

let commit = (state, action, megastate) => {
	let obj = state.buffer[Object.keys(state.buffer)[0]] || {}
	let type = (obj && obj.type) || (state.db[obj._id] && state.db[obj._id].type)
    if(type == "project" && !state.db[obj._id]){
		state = projectCreate(state, action, megastate)
	} else if(type == "application"){
		state = applicationCreate(state, action, megastate)
	}
    let transaction = obj._id && state.db[obj._id] || state.buffer[obj._id]
    if(transaction && (transaction.type == "transaction/bill" || transaction.type == "transaction/invoice")){
        let transaction = {
  	        ...R.map(
  	            change => ({
  	                ...state.db[change._id]
  	              , ...change
  	            })
  	          , state.buffer
  	        )
  	    }[Object.keys(state.buffer)[0]]
        if ((transaction.partyID || transaction.vendorID) && transaction.propertyID && transaction.amount>0 && transaction.dueDate
            && ((transaction.isPaid && transaction.isPaid.toString()=="true") || transaction.type== "transaction/invoice" || transaction.paymentMethod == "QuickBooks")
        ){
            state.buffer[Object.keys(state.buffer)[0]].readyToPay=true
        }else state.buffer[Object.keys(state.buffer)[0]].readyToPay=false
	}
	return {
	    ...state
	  , db: {
	        ...state.db
	      , ...R.map(
	            change => ({
	                ...state.db[change._id]
	              , ...change
	            })
	          , state.buffer //R.filter(bufferedDoc => !action.data.indexOf(bufferedDoc._id), state.buffer)
	        )
	    }
	  , buffer: {} //R.filter(bufferedDoc => action.data.indexOf(bufferedDoc._id), state.buffer)
	  , edit: ''
	}
}

let applicationCreate = (state, action, megastate) => {
	let applicationBuffer = state.buffer[Object.keys(state.buffer)[0]]
	let db = state.db
	let application = db[applicationBuffer._id]
	let leases = leasesByApplicationID(megastate)
	if( !applicationBuffer.status
		|| (applicationBuffer.status == 'new' || applicationBuffer.status == 'rejected')
		|| (application.status == applicationBuffer.status)
		|| !application.listingID
		|| leases[application._id]
	) return state
	let listing = getlistingsByPropertyID(megastate, application.propertyID)
	let lease = {
		[action._id]: {
			_id: action._id
		  , propertyID: application.propertyID
		  , tenantID: action._id + "0"
		  , applicationID: application._id
		  , date: Moment(action.date).format("YYYY-MM-DD")
		  , dateFrom: Moment(application.primaryResident.moveIn, "MM/DD/YYYY").format("YYYY-MM-DD")
		  , dateTill: Moment(application.primaryResident.moveIn, "MM/DD/YYYY").add("1", "year").subtract("1", "day").format("YYYY-MM-DD")
		  , rent: listing.rent
		  , securityDeposit: listing.securityDeposit || 0
      , petDeposit: listing.petDeposit || 0
		  , lateFee: 0
		  , notificationPeriod: 30
		  , type: "lease"
		}
	}
	let tenants = {
		[action._id + "0"] : {
			_id: action._id + "0"
		  , applicationID: application._id
		  , firstName: application.primaryResident.firstName
		  , lastName: application.primaryResident.lastName
		  , phoneNumber: application.primaryResident.cell
		  , email: application.primaryResident.email
		  , type: "tenant"
		}
	}
	application.additionalResidents.map((tenant, indx) => {
		if(tenant.age.indexOf("Child") != -1) return
		let newID = action._id + ++indx
		let newTenant = {
			_id: newID
  		  , applicationID: application._id
  		  , parentID: action._id + "0"
		  , firstName: tenant.firstName
		  , lastName: tenant.lastName
		  , phoneNumber: tenant.cell
		  , email: tenant.email
		  , type: "tenant"
		}
		tenants = {
			...tenants
		 , [newTenant._id]: newTenant
		}
	})
	let listingEnd = {
		[listing._id] : {
			_id: listing._id
		  , dateTill: Moment(action.date).format("YYYY-MM-DD")
		}
	}
	return ({
		...state
	  , buffer:{
			[applicationBuffer._id]: applicationBuffer
		  , ...lease
		  , ...tenants
		  , ...listingEnd
		}
	})
}

let projectCreate = (state, action, megastate) => {
	let projectBuffer = state.buffer[Object.keys(state.buffer)[0]]
	let db = state.db
	let template = db[projectBuffer.templateID]
	let todos = template.todos
	let tasks = todos.map((todo, idx) => ({
		_id: `${projectBuffer._id}-${idx}`
		, taskContent: todo.name
		, projectID: projectBuffer._id
		, propertyID: projectBuffer.propertyID
		, done : false
		, status: "Open"
		, urgent: false
		, note: ""
		, schedule: {
			  curStart: action.date
			, curDue: new Date(Moment(action.date).add(todo.duration || 1, 'days'))
			, curDuration: todo.duration || 1
			, curStrictStart: todo.strictStart ||  false
			, curStrictDue: todo.strictDue || false
		  }
		, managerID : projectBuffer.ownerID
		, dependencies : R.map(idx => `${projectBuffer._id}-${idx}`, todo.dependencies || [])
		, type: 'task'
		, taskType: todo.taskType || 'Admin'
	}))
	let propertyID = projectBuffer.propertyID
	let title = template.title //+ ', ' + (propertyID == 'All' ? 'All' : db[propertyID].alias)
	let lease = lastPropertyLease(megastate, {propertyID})
	let tenant = lease && lease.tenantID
	let newProject = {
		_id: projectBuffer._id
	  , title
	  , propertyID : projectBuffer.propertyID
	  , managerID : projectBuffer.ownerID
	  , status : 'Open'
	  , tenant
	  , date : action.date
	  , isForAll: propertyID == "All"
	  , type: 'project'
	}
	return ({
	    ...state
	  , buffer: {
			[newProject._id]: newProject
		  , ...R.indexBy(R.prop('_id'), tasks)
		}
	})
}

let stage = (state, action) => {
    let buffer = (action || {}).data || {}
    let data = (state || {}).db[buffer._id] || {}
    data = {
        ...data
      , ...state.buffer[action.data._id]
    }
    for (let key in buffer){
        if (!R.equals(buffer[key], data[key]) && (!data[key] != !buffer[key] || !!data[key])) {
            return({
                ...state
                , buffer: {
                	...state.buffer
                	, [action.data._id]: {
                		...state.buffer[action.data._id]
                		, ...action.data
                	}
                }
            })
        }
    }
    return state
    // return({
    //     ...state
    //     , buffer: {
    //         ...state.buffer
    //         , [action.data._id]: {
    //             ...state.buffer[action.data._id]
    //             , ...action.data
    //         }
    //     }
    // })
}

let discard = (state, action) => ({
    ...state
  , buffer: {}
  , edit: ''
})
let add = (state, action, megastate) => ({
    ...state
  , buffer: {
        ...state.buffer
      , [action._id]: {
            ...state.buffer[action._id]
          , ...action.data
          , '_id': action._id
        }
    }
  , edit: action.data.type
})
let deleteNotifications = (commentID) => R.reject(x => x.type == 'notification' && x.commentID == commentID)
let equals = (changes, obj) => {
	return R.all(x => changes[x] == obj[x])(R.keys(changes))
}

export default createReducer(initialState, {
	DATA_DOWNLOAD_OK: (state, action) => ({
		...state
	  , db: action.data
    })
  , DATA_SAVE_OK: (state, action, megastate) => ({
  		...state
  	  , replicated: megastate.session.username
  	  , updated: true
    })
  , DATA_UPDATE_OK: (state, action) => ({
  		...state
  	  , updated: true
    })
  , DATA_LOAD_OK: (state, action) => ({
		...state
	  , db: action.data
  	})
  , DATA_INDEX: (state, action) => ({
		...state
	  , idx: action.data
  	})
  , DOC_EXTERNAL_UPDATE: (state, action) => ({
		...state
	  , db: {
			...state.db
		  , [action.data._id]: action.data
		}
	})
  , DOC_DELETE: (state, action) => ({
		...state
	  , db: R.dissoc(action.data, state.db)
	  , buffer: R.dissoc(action.data, state.buffer)
    })
  , LOGOUT: (state, action, megastate) => ({
  		...state
  	  , replicated: undefined
    })
  , ADD: add
  , NEW_PAYMENT: add
  , NEW: (state, action) => {
		if (Object.keys(state.buffer).lenght > 0) return state
		return { ...stage(state, action), edit: action.data.type }
	}
  , EDIT: (state, action) => ({...state, edit: action.data})
  , PAID: (state, action, megastate) => ({
    		  ...state
    		, db:{
    			  ...state.db
    			, [action.data._id]: {
    				...state.db[action.data._id]
    				, paid: action.data.paid
    				, isPaid: action.data.paid
    				, paidAmount:  action.data.paidAmount
    				, paidDate:  action.data.paidDate
    			}
    		  }
    })
  , ROLLBACK: discard
  , DISCARD_AND_NAVIGATE: discard
  , COMMIT: commit
  , OK: commit
  , CLOSE: (state, action) => state
  , CLOSE_YES: (state, action) => ({...state, buffer: {}})
  , ROLLBACK: (state, action) => ({...state, buffer: {}})
  , DELETE_YES: (state, action) => ({
  		...state
  	  , db: R.reject(
  				R.propEq('_id', action.data)
  			  , state.db
  			)
  	  , buffer: {}
  	})
  , STAGE: stage
  , LINE_ADD: stage
  , DOC_UPDATE: (state, action, megastate) => ({
		...state
	  , db:{
			...state.db
		  , [action.data._id]: (!state.db[action.data._id])?
				{
					  ...action.data
				}
				:
				(!equals(action.data, state.db[action.data._id]))?
					{
						...state.db[action.data._id]
					  , ...action.data
					}
					:
					state.db[action.data._id]
		}
	})
  , COMMENT_SAVE: (state, action, megastate) => {
		let managerIDs = managersMentions(action.data.contents)
    if (!managerIDs.length){
        managerIDs.push("ae33de19-79c0-45d2-a6ea-f568c8e58327")
    }
		let notifications = {}
		managerIDs.map((manager, indx) => {
				let newID = action._id + indx
				let newNotification = {
					_id: newID
				  , commentID: action.data._id
				  , from: action.data.userID
				  , to: manager
				  , read: false
				  , done: false
				  , type: "notification"
				}
				notifications = {
					...notifications
				  , [newNotification._id]: newNotification
				}
		})
		return ({
			...state
		  , db:{
				...deleteNotifications(action.data._id)(state.db)
			  , [action.data._id]: (state.db[action.data._id])?
					{
						...state.db[action.data._id]
					  , ...action.data
					}
					: {
						...action.data
					}
			  , ...notifications
			}
		})
	}
, COMMENT_READ: (state, action) => ({
  ...state
  , db: {
    ...state.db
    , [action.data._id]: {
            ...state.db[action.data._id]
          , read: true
        }
  }
  })
  , COMMENT_DELETE_YES: (state, action) => ({
    		...state
    	  , db: R.reject(
    				R.propEq('_id', action.data)
    			  , deleteNotifications(action.data)(state.db)
    			)
    })
  , PROJECT_REPAIRMEN_OK: (state, action, megastate) => ({
    		...state
    	  , db:{
            ...state.db
          , ...megastate.repairmenSelect.repairmen
       }
    })
  , ATTACHMENT_DELETE: (state, action) => ({
			...state
		  , db: R.reject(
					R.propEq('_id', action.data)
				  , state.db
				)
		})
  , DOC_EXTERNAL_UPDATE: (state, action) => ({
		...state
	  , db: {
			...state.db
		  , [action.data._id]: action.data
		}
	})
  , '@@router/LOCATION_CHANGE': (state, action) => ({...state, edit: ''})
//   	, COMMIT: (state, action, megastate) => ({
// 		...state
// 	  , db: {
// 			...state.db
// 		  , ...R.map(
// 			  	change => ({
// 					...state.db[change._id]
// 				  , updatedAt: action.date.valueOf()
// 				  , updatedBy: megastate.login.userName
// 				  , ...change
// 				})
// 			  , state.buffer //R.filter(bufferedDoc => !action.data.indexOf(bufferedDoc._id), state.buffer)
// 			)
// 		}
// 	  , buffer: {} //R.filter(bufferedDoc => action.data.indexOf(bufferedDoc._id), state.buffer)
// 		, edit: ''
// 	})
})



// WEBPACK FOOTER //
// ./src/reducers/data.js